// src/Callback.tsx

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import oktaAuth from './oktaService';
import {TokenManagerInterface} from '@okta/okta-auth-js';

const tokenManager: TokenManagerInterface = oktaAuth.tokenManager;

const Callback: React.FC = () => {

  const navigate = useNavigate();
  let error = ""

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Parse the tokens from the URL
        const tokens = await oktaAuth.token.parseFromUrl();
        console.log('tokens:', tokens);
        // Store tokens or do further processing here. For example, store tokens in session storage
        sessionStorage.setItem('accessToken', tokens.tokens.accessToken!.accessToken);
        sessionStorage.setItem('name', JSON.stringify(tokens.tokens.idToken!.claims.name));

        // Redirect to home or another page
        navigate('/home');
      } catch (err) {
        console.error('Error handling Okta callback:', err);
        if ((err as Error).name != "AuthSdkError"){
          navigate('/accessInstructions')
        }
      }
    };

    handleCallback();
  }, [navigate]);

  // TO FIX: Implement error handling here, for example: User is not assigned to the application
  // currently just gets stuck on loading... if there is an error
  return( 
    <h2 style={{}}>Loading...</h2>
  );
};

export default Callback;
